import { cn } from "../../lib/utils"
import { Button as ButtonBase, type ButtonProps as ButtonBaseProps } from "../ui/button"

export type ButtonProps = ButtonBaseProps & {
  // biome-ignore lint/suspicious/noExplicitAny: permissive
  btnRef?: any
}

export function Button({ className, btnRef, ...props }: ButtonProps) {
  return <ButtonBase ref={btnRef} className={className} {...props} />
}

export const DropdownButton = ({ btnRef, ...props }: ButtonProps) => {
  return (
    <Button
      {...props}
      btnRef={btnRef}
      className={cn("buoy-dropdown-btn group", props.className)}
      iconEnd={"ChevronDown"}
    />
  )
}

Button.displayName = "Button"
DropdownButton.displayName = "DropdownButton"
